<div class="w-full p-10 cst-content-ctnr mt-8">
  <div class="w-full p-8 bg-white dark:bg-gray-800 flex-col justify-start items-start gap-2.5 inline-flex rounded-lg">
    <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
      <div class="w-full grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
        <div class="mb-3">
          <div class="mb-3 w-full self-stretch text-gray-900 text-4xl font-semibold leading-[38px]">
            Créer un utilisateur
          </div>
          <p class="text-slate-600 text-base">
            Vous pouvez créer ci-dessous des utilisateurs
          </p>
        </div>

        <div>
          <div class="lg:flex justify-end">
            <div class="bg-green-500 border border-400 text-white px-4 py-3 rounded relative" role="alert"
              *ngIf="notification">
              <strong class="font-bold text-white mr-2">Réussie :</strong>
              <span class="block sm:inline">
                votre utilisateur a été créé !</span>
            </div>
            <div class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative" role="alert"
              *ngIf="errorCountExist">
              <strong class="font-bold text-red mr-2">Erreur</strong>
              <span class="block sm:inline">Un compte avec l'adresse mail {{ email }} existe déja
              </span>
            </div>
            <div class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative" role="alert"
              *ngIf="error">
              <strong class="font-bold text-red mr-2">Erreur</strong>
              <span class="block sm:inline">Erreur lors de la création de l'utilisateur
              </span>
            </div>
            <div class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative" role="alert"
              *ngIf="valid">
              <strong class="font-bold text-red mr-2">Erreur</strong>
              <span class="block sm:inline">Merci de remplir tous les champs
              </span>
            </div>
          </div>
        </div>
        <hr class="h-px my-2 bg-gray-300 border-0 dark:bg-gray-700" />

        <form class="w-full grow shrink p-6" [formGroup]="createUserForm">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
            <div class="mb-4 pb-0">
              <label class="mb-1 pr-db font-semibold inter-medium f14 color-gray-700 w-full" for="prenom">Prénom</label>
              <input type="text" id="prenom"
                class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                formControlName="firstname" />
            </div>
            <div class="mb-4 pb-0">
              <label class="mb-1 pr-db font-semibold f14 color-gray-700 w-full" for="lastname">Nom</label>
              <input type="text" id="lastname"
                class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                formControlName="lastname" />
            </div>
            <div class="mb-4 pb-0">
              <label class="mb-1 pr-db font-semibold inter-medium f14 color-gray-700 w-full" for="sexe">Sexe</label>
              <select formControlName="selectedGender" id="sexe"
                class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2">
                <option value="" disabled selected class="text-gray-200">
                  Renseignez le sexe
                </option>
                <option *ngFor="let gender of genders" [value]="gender.id">
                  {{ gender.name }}
                </option>
              </select>
            </div>
            <div class="mb-4 pb-0">
              <label class="mb-1 pr-db font-semibold f14 color-gray-700 w-full" for="email">Adresse e-mail</label>
              <input type="text" id="email"
                class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                formControlName="email" />
            </div>

            <div class="mb-4 pb-0">
              <label class="mb-1 pr-db font-semibold inter-medium f14 color-gray-700 w-full" for="country">
                Pays <span class="text-red-500">*</span>
              </label>
              <select formControlName="selectedCountry" id="country"
                class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2">
                <option value="" disabled selected class="text-gray-200">
                  Renseignez le pays
                </option>
                <option *ngFor="let c of AVAILABLE_COUNTRIES" [ngValue]="{ id: c.id, name: c.name }">
                  {{ c.name }}
                </option>
              </select>
            </div>
            <div class="mb-4 pb-0">
              <label class="mb-1 pr-db font-semibold inter-medium f14 color-gray-700 w-full" for="profils">Rôles</label>
              <select formControlName="selectedProfil" id="profils"
                class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2">
                <option value="" disabled selected class="text-gray-200">
                  Renseignez le rôle
                </option>
                <option *ngFor="let role of roles" [ngValue]="role">
                  {{ role.libelle }}
                </option>
              </select>
            </div>
            <div class="mb-4 pb-0" *ngIf="isResponsableBenin">
              <label class="mb-1 pr-db font-semibold inter-medium f14 color-gray-700 w-full" for="structure">
                Structure / Partenaire <span class="text-red-500">*</span>
              </label>
              <select formControlName="structure" id="structure"
                class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                [class.border-red-500]="
          createUserForm.get('structure')?.invalid &&
          createUserForm.get('structure')?.touched
        ">
                <option value="" disabled selected class="text-gray-200">
                  Sélectionnez la structure du partenaire
                </option>
                <option *ngFor="let list of listpartenairebenin" [value]="list">
                  {{ list }}
                </option>
              </select>
              <div *ngIf="
          createUserForm.get('structure')?.invalid &&
          createUserForm.get('structure')?.touched
        " class="text-red-500 text-xs mt-1">
                La sélection de la structure est obligatoire pour les
                responsables Bénin.
              </div>
            </div>

          </div>
          <div class="form-fields-ctnr reset-submit w-full self-stretch justify-end items-end gap-6 inline-flex">
            <div class="w-full flex pt-6 justify-end items-end gap-5">
              <button (click)="onSubmitForm()" style="border-radius: 0.5em" type="button"
                class="text-white mat-mdc-input-element bg-blue bg-blueDark text-sm self-stretch px-3.5 py-2.5 font-semibold shadow border border-gray-300 justify-start items-center gap-2 inline-flex">
                Créer un utilisateur
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>